/* Progressive reveal for LV sections. Safe for Shopify Theme Editor reloads. */
(function () {
  var selector = '.lv-reveal';
  var observer;

  function show(element) {
    element.classList.remove('lv-reveal-pending');
    element.classList.add('lv-reveal-shown');
    if (observer) observer.unobserve(element);
  }

  function getObserver() {
    if (observer) return observer;
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) show(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    return observer;
  }

  function init(scope) {
    var elements = [];
    if (scope.matches && scope.matches(selector)) elements.push(scope);
    if (scope.querySelectorAll) {
      scope.querySelectorAll(selector).forEach(function (element) {
        elements.push(element);
      });
    }

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    elements.forEach(function (element) {
      if (element.classList.contains('lv-reveal-shown')) return;
      if (reduceMotion || !('IntersectionObserver' in window)) show(element);
      else {
        element.classList.add('lv-reveal-pending');
        getObserver().observe(element);
      }
    });
  }

  function start() { init(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
